import * as React from 'react'
import { IActiveTripResponseV2 } from '../../../types'
import UIMessages from '../../../utils/ui-messages'
import UserLogo from '../../icons/ui/UserLogo'
import { mapViewStrategyStages } from '../../MapView'
import TripActivityLog from '../../../containers/trips/TripActivityLog'

export interface ITripBookingFailedProps {
  currentTrip: IActiveTripResponseV2
  setCurrentTripStage: (stage: string) => void
}

class TripBookingFailed extends React.Component<ITripBookingFailedProps> {
  public componentDidMount() {
    this.props.setCurrentTripStage(mapViewStrategyStages.showPolyline)
  }

  public render() {
    const trip = this.props.currentTrip

    if (!trip) {
      return null
    }

    const operatorName = trip.operator ? `${trip.operator.firstName} ${trip.operator.lastName}` : 'No operator assigned'
    console.log('TRIP: ', trip)

    return (
      <React.Fragment>
        <div className='px2 py2'>
          <div className='flex '>
            <div className='col-10 pl2'>
              <div className='flex'>
                <div>{operatorName}</div>
              </div>
              <div className='h6 font-grey2'>
                {trip.service.name} {trip.product.name}
              </div>
              {/* <TripActivityLog currentTripId={this.props.currentTrip.id} /> */}
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default TripBookingFailed



// WEBPACK FOOTER //
// ./src/components/trips/trip-detail/TripBookingFailed.tsx